import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { inputFields, tables, Buttons } from "../../components";

import { UniversityAction } from "../../store/actions";

const ApplicationJourney = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];

  const { universityAdmin, isLoading } = useSelector(
    (state) => state?.university
  );

  const [state, setState] = useState({
    appJourneys: [],
  });

  useEffect(() => {
    setState({
      appJourneys: universityAdmin?.appJourneys ?? [],
    });
  }, [universityAdmin]);

  const handleAppJourneyChange = (index, field, value) => {
    const updatedAppJourneys = [...state.appJourneys];
    updatedAppJourneys[index][field] = value;
    setState({ ...state, appJourneys: updatedAppJourneys });
  };

  const addAppJourney = () => {
    const newAppJourney = {
      uniID: parseInt(id),
      title: "",
      details: "",
    };
    setState({
      ...state,
      appJourneys: [...state.appJourneys, newAppJourney],
    });
  };

  const removeAppJourney = (index) => {
    const updatedAppJourneys = state.appJourneys.filter((_, i) => i !== index);
    setState({ ...state, appJourneys: updatedAppJourneys });
  };

  const handleSubmit = () => {
    const payload = {
      id: parseInt(id),
      page: "appJourneys",
      data: state,
    };

    dispatch(
      UniversityAction.editUniversity(payload, () => {
        dispatch(UniversityAction.getUniversityDetailsAdmin(id));
      })
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleAppJourneyChange(index, "title", e.target.value)
          }
        />
      ),
    },
    {
      title: "Details",
      dataIndex: "details",
      width: 350,
      render: (text, record, index) => (
        <inputFields.DefaultTextbox
          value={text}
          onChange={(e) =>
            handleAppJourneyChange(index, "details", e.target.value)
          }
        />
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeAppJourney(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.appJourneys}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
          loading={isLoading}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addAppJourney}>
          Add More
        </Buttons.DefaultButton>
        <Buttons.DefaultButton size="medium" onClick={handleSubmit}>
          Save Changes
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default ApplicationJourney;
